import { ref, onMounted, onBeforeUnmount } from 'vue'

/**
 * Simple online/offline detector using the Browser Network Information API.
 * - Exposes `isOnline` and `isOffline` refs
 * - Listens to window `online`/`offline` events
 * - Initializes state from `navigator.onLine`
 */
export function useNetworkStatus() {
  const isOnline = ref(true)
  const isOffline = ref(false)

  const updateStatus = () => {
    // navigator.onLine can be undefined in some environments; default to true
    const online = typeof navigator !== 'undefined' && 'onLine' in navigator ? navigator.onLine : true
    isOnline.value = online
    isOffline.value = !online
  }

  const handleOnline = () => {
    isOnline.value = true
    isOffline.value = false
  }

  const handleOffline = () => {
    isOnline.value = false
    isOffline.value = true
  }

  onMounted(() => {
    updateStatus()
    if (typeof window !== 'undefined') {
      window.addEventListener('online', handleOnline)
      window.addEventListener('offline', handleOffline)
    }
  })

  onBeforeUnmount(() => {
    if (typeof window !== 'undefined') {
      window.removeEventListener('online', handleOnline)
      window.removeEventListener('offline', handleOffline)
    }
  })

  return { isOnline, isOffline }
}
